import { render, staticRenderFns } from "./MarkTabContent.vue?vue&type=template&id=56d7a37a"
import script from "./MarkTabContent.vue?vue&type=script&lang=js"
export * from "./MarkTabContent.vue?vue&type=script&lang=js"
import style0 from "./MarkTabContent.vue?vue&type=style&index=0&id=56d7a37a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports